import './styles.scss';

/*
  TODO: delete this comment

  This file is where you bootstrap your JS code
  For example import stuff here:

  import {select} from 'd3-selection';
  import myComponent from './components/my-component';

  ... you code here

*/

// Need at the moment to to wire up
// some standard page components
document.dispatchEvent(new CustomEvent('ig.Loaded'));



// WEBPACK FOOTER //
// ./client/index.js